import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import type { BulkOperation } from "src/api/bulk-operations/type";
import useAuth from "src/hooks/useAuth";
import { Query } from "src/types/query";
import axios from "src/utils/axios";

export function useQueryUnseenBulkOperations(): UseQueryResult<BulkOperation[]> {
    const { user } = useAuth();

    return useQuery({
        queryKey: [Query.UnseenBulkOperations, user.organization.id],
        queryFn: async () => {
            const { data } = await axios.get<BulkOperation[]>("/bulk-operation/unseen");
            return data;
        },
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval: (query) => {
            if (query.state.status === "error") {
                return 0;
            }

            const bulkOperations = query.state.data ?? [];

            if (bulkOperations.length === 0) {
                return 0;
            }

            const hasProcessingOperation = bulkOperations.some(
                (operation) => operation.status === "pending" || operation.status === "inProgress"
            );

            if (!hasProcessingOperation) {
                return 0;
            }

            return 2000;
        },
    });
}
